import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types"
import { toast } from 'react-toastify';
import { Div, MESES_GESTACION } from './components/Components';
import Gestante from './components/Gestante';
import Lactancia from './components/Lactancia';
import ModalForm from '../../../components/modalComponents/ModalForm'
import InputText from '../../../components/modalComponents/InputText';
import InputDate from '../../../components/modalComponents/InputDate';
import InputSelect from '../../../components/modalComponents/InputSelect';
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading';
import InputUploadFile from '../../../components/modalComponents/InputUploadFile';
import { useSubmitForm } from '../../../hooks/useSubmitForm/useSubmitForm';
import { usePropsInputs } from '../../../hooks/useProps/usePropsInput';
import { usePropsSelect } from '../../../hooks/useProps/usePropsSelect';
import { useGetOptionsSelect } from '../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import { DM_CONDICION, MATERNIDAD_CONDICION } from '../../../constants/hardCodedConstants';
import { initialAllOptionPromises, isNullOrUndefinded, toIsoForInput } from '../../../helper/utils';
import { updateValidationMessage, clearAllInputValidationMessages } from '../../../validations/FormValidatorUtils';
import {
  getInfoToCreateCondicionAPI,
  getInstitucionesDescansoMedicoAPI,
  getMotivosDescansoMedicoAPI,
  getCIE10API,
  getTipologiaAPI,
  getTipoDeCondicionAPI,
  registrarCondicionAPI,
  getEmpleadosToCreateCondicionAPI,
  registrarSolicitudLicenciaCondicionAPI
} from '../../../consumers/backendApisUrls';
import DescansoMedico from './components/DescansoMedico';

import {useManageGetRequest} from '../../../hooks/useManageGetRequest/useManageGetRequest';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import InputSearchAsync from '../../../components/modalComponents/InputSearchAsync';
import LicenciaCondicion from "./Licencias/LicenciaCondicion";
import {KEYS_LICENCIAS} from "./Licencias/LicenciasContantes";


const KEYS = {
  idEmpleado: "IdEmpleado",
  idTipoDeCondicion: "IdTipoDeCondicion",
  meses: "MesesGestacion",
  fechaNacimiento: "FechaNacimiento",
  fechaProbable: "FechaProbableDeParto",
  fechaUltMenstruacion: "FechaUltimaMenstruacion",
  nombre: "NombreBebe",
  file: "SustentoFile",
  fechaInicioCondicion: "FechaInicioCondicion",
  fechaFinCondicion: "FechaFinCondicion",
  diagnostico: "Diagnostico",
  idMotivoDescansoMedico: "IdMotivoDescansoMedico",
  motivoDescansoMedico: "MotivoDescansoMedico",
  idInstitucionDescansoMedico: "IdInstitucionDescansoMedico",
  institucionDescansoMedico: "InstitucionDescansoMedico",
  idCIE10: "IdCIE10",
  cie10Otro: "CIE10Otro",
  cmp: "CMP",
  nombreMedico: "NombreMedico",
  idTipologia: "IdTipologia",
  tipologiaOtro: "TipologiaOtro",
  nombreInstitucionEmisora: "NombreInstitucionEmisora",
  documentos: "Documentos",
  declaracionJurada: "DeclaracionJurada",
};

const KEYS_DROPDOWN = ["IdTipoDeCondicion", "IdMotivoDescansoMedico", "IdInstitucionDescansoMedico", "IdCIE10", "IdTipologia"];
const SECTION_NAME = "CrearPopUpGenerico";

const CrearMaternidad = ({ toggleModal, refreshPage, isAdmin, idEmpleado: idEmpleadoProp }) => {
  const [executeManageGetRequest] = useManageGetRequest();
  const [executeManagePost] = useManagePostRequest();
  const [formValuesLicencias, setFormValuesLicencias] = useState({});

  const [formValues, setFormValues] = useState({});
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [checkDeclaracionJurada, setCheckDeclaracionJurada] = useState(false);

  const [fromAdminPage, setFromAdminPage] = useState(idEmpleadoProp === 0);

  const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
  const [selectProps] = usePropsSelect(allDropdowns, formValues, setFormValues, SECTION_NAME);
  const [getOption] = useGetOptionsSelect();
  const [submitForm] = useSubmitForm();

  const [dataToCreate, setDataToCreate] = useState({});

  // Tipologia solo se ve desde Gestion de Licencias y DM, nunca desde Mis Licencias y DM
  const puedeVerCamposAdmin = fromAdminPage && dataToCreate?.PuedeVerCamposAdministrativosDM === true;

  const [currentIdEmpleado, setCurrentIdEmpleado] = useState(idEmpleadoProp);
  

  const getDropdowns = async (idEmpleado) => {
    //setIsLoading(true);
    const dropdownsPromises = () => [
      getOption(getTipoDeCondicionAPI(idEmpleado)),
      getOption(getMotivosDescansoMedicoAPI()),
      getOption(getInstitucionesDescansoMedicoAPI()),
      getOption(getCIE10API()),
      getOption(getTipologiaAPI())
    ]
    await initialAllOptionPromises( dropdownsPromises, KEYS_DROPDOWN, handleDropdowns );
    //setIsLoading(false);
  }

  const handleDropdowns = (data) => {
    const updatedData = [...data, {key: KEYS.meses, value: MESES_GESTACION}];
    setAllDropdowns(updatedData);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let api = "";
    let payload= {}
    let keys = [];

    if (formValues[KEYS.idTipoDeCondicion] === DM_CONDICION.LICENCIA)
    {
      api = registrarSolicitudLicenciaCondicionAPI();
      payload = {...formValuesLicencias, IdEmpleado: currentIdEmpleado, FromAdminPage: fromAdminPage};
      keys = KEYS_LICENCIAS;
    }else {
      api = registrarCondicionAPI();
      payload = getPayload();
      keys = KEYS;
    }

    if (formValues[KEYS.idTipoDeCondicion] === DM_CONDICION.DESCANSO_MEDICO) {
      clearAllInputValidationMessages(
        [KEYS.idCIE10, KEYS.cie10Otro, KEYS.cmp, KEYS.nombreMedico, KEYS.idTipologia, KEYS.tipologiaOtro, KEYS.nombreInstitucionEmisora],
        SECTION_NAME
      );
      let hasError = false;
      if (!formValues[KEYS.idCIE10]) {
        updateValidationMessage(KEYS.idCIE10, "CIE-10 es obligatorio", SECTION_NAME);
        hasError = true;
      }
      if (formValues[KEYS.idCIE10] === 9999 && !formValues[KEYS.cie10Otro]) {
        updateValidationMessage(KEYS.cie10Otro, "Debe especificar el diagnóstico CIE-10", SECTION_NAME);
        hasError = true;
      }
      if (!formValues[KEYS.cmp]) {
        updateValidationMessage(KEYS.cmp, "CMP es obligatorio", SECTION_NAME);
        hasError = true;
      }
      if (!formValues[KEYS.nombreMedico]) {
        updateValidationMessage(KEYS.nombreMedico, "Nombre del Médico es obligatorio", SECTION_NAME);
        hasError = true;
      }
      if (puedeVerCamposAdmin && !formValues[KEYS.idTipologia]) {
        updateValidationMessage(KEYS.idTipologia, "Tipología es obligatorio", SECTION_NAME);
        hasError = true;
      }
      if (puedeVerCamposAdmin && formValues[KEYS.idTipologia] === 9999 && !formValues[KEYS.tipologiaOtro]) {
        updateValidationMessage(KEYS.tipologiaOtro, "Debe especificar la tipología", SECTION_NAME);
        hasError = true;
      }
      if (!formValues[KEYS.nombreInstitucionEmisora]) {
        updateValidationMessage(KEYS.nombreInstitucionEmisora, "Nombre de Institución Emisora es obligatorio", SECTION_NAME);
        hasError = true;
      }
      if (!checkDeclaracionJurada) {
        toast.error("Es obligatorio confirmar que la información y los documentos presentados son verídicos para poder completar su registro.");
        hasError = true;
      }
      if (hasError) {
        setIsSubmitting(false);
        return;
      }
    }

    try {
      await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitCallback);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  }

  const getPayload = () => {

    const { IdTipoDeCondicion, ...rest } = formValues
    let selectedStates = {};
    if (formValues[KEYS.idTipoDeCondicion] === MATERNIDAD_CONDICION.GESTANTE){
      const { FechaProbableDeParto, MesesGestacion, FechaUltimaMenstruacion, SustentoFile } = rest;
      selectedStates = { FechaProbableDeParto, MesesGestacion, FechaUltimaMenstruacion, SustentoFile };
    }
    if (formValues[KEYS.idTipoDeCondicion] === MATERNIDAD_CONDICION.LACTANCIA){
      const { FechaNacimiento, NombreBebe, SustentoFile } = rest;
      selectedStates = { FechaNacimiento, NombreBebe, SustentoFile };
    }
    if (formValues[KEYS.idTipoDeCondicion] === DM_CONDICION.DESCANSO_MEDICO){
      const {
        FechaInicioCondicion,
        FechaFinCondicion,
        Diagnostico,
        IdMotivoDescansoMedico,
        IdInstitucionDescansoMedico,
        Documentos,
        IdCIE10,
        CIE10Otro,
        CMP,
        NombreMedico,
        IdTipologia,
        TipologiaOtro,
        NombreInstitucionEmisora,
      } = rest;
      selectedStates = {
        FechaInicioCondicion,
        FechaFinCondicion,
        Diagnostico,
        IdMotivoDescansoMedico,
        IdInstitucionDescansoMedico,
        Documentos,
        IdCIE10,
        CIE10Otro,
        CMP,
        NombreMedico,
        IdTipologia,
        TipologiaOtro,
        NombreInstitucionEmisora,
        DeclaracionJurada: checkDeclaracionJurada,
      };
    }
    return {
      IdEmpleado: currentIdEmpleado,
      IdTipoDeCondicion,
      ...selectedStates
    }
  }

  const successSubmitCallback = async () => {
    toggleModal();
    await refreshPage();
  }

  function canCreate() {
    return formValues[KEYS.idTipoDeCondicion] === MATERNIDAD_CONDICION.LACTANCIA
      ? dataToCreate?.PuedeCrearLactancia
      : true;
  }

  useEffect(() => {
    getDropdowns(currentIdEmpleado);
    getInfoToCreateFunction(currentIdEmpleado);
  }, [])


  useEffect(() => {
    if (!isNullOrUndefinded(formValues?.IdEmpleado))
    {
      setCurrentIdEmpleado(formValues?.IdEmpleado);
      updateEmpleadoData(formValues?.IdEmpleado);
      setFormValues({...formValues, IdTipoDeCondicion: null})
    }

      
  }, [formValues?.IdEmpleado])

  useEffect(() => {
    if (dataToCreate && !isNullOrUndefinded(dataToCreate.TieneComeci)) {
      setFormValues(prev => ({ ...prev, Comeci: dataToCreate.TieneComeci }));
    }
  }, [dataToCreate])

  useEffect(() => {
    if (dataToCreate) {
      setFormValues(prev => ({
        ...prev,
        Excede140Consecutivo: dataToCreate.Excede140Consecutivo || false,
        Excede80NoConsecutivo: dataToCreate.Excede80NoConsecutivo || false,
        EstariaExcediendo140Consecutivo: dataToCreate.EstariaExcediendo140Consecutivo || false,
        EstariaExcediendo80NoConsecutivo: dataToCreate.EstariaExcediendo80NoConsecutivo || false
      }));
    }
  }, [dataToCreate])

  useEffect(() => {
    if (formValues[KEYS.idTipoDeCondicion] === DM_CONDICION.DESCANSO_MEDICO &&
        formValues[KEYS.fechaInicioCondicion] &&
        formValues[KEYS.fechaFinCondicion]) {
      getInfoToCreateFunction(currentIdEmpleado,
        formValues[KEYS.fechaInicioCondicion],
        formValues[KEYS.fechaFinCondicion]);
    }
  }, [currentIdEmpleado, formValues[KEYS.idTipoDeCondicion], formValues[KEYS.fechaInicioCondicion], formValues[KEYS.fechaFinCondicion]])

  const updateEmpleadoData = async (idEmpleado) => {
    await getInfoToCreateFunction(idEmpleado, null, null);
    await getDropdowns(idEmpleado);
  }

  const getInfoToCreateFunction = async (idEmpleado, fechaInicio = null, fechaFin = null) => {
    const payload = {
      IdEmpleado: idEmpleado,
      FechaInicioCondicion: fechaInicio,
      FechaFinCondicion: fechaFin
    };
    await executeManagePost(getInfoToCreateCondicionAPI(), payload, (res) => setDataToCreate(res.data), false);
  }

  if (isLoading) return <SpinnerLoading />

  const CommonData = (
    <>
      <Div>
        <InputDate
          label="Fec. Reg."
          value={toIsoForInput(new Date())}
          isDisabled
        />
      </Div>
      <Div>
        <InputText
          name="Estado"
          label="Estado"
          value="Pendiente de Aprobación"
          isDisabled
        />
      </Div>
      <Div>
        <InputSelect
          label="Condición"
          isRequired={true}
          {...selectProps(KEYS.idTipoDeCondicion, [
            KEYS.fechaProbable,
            KEYS.fechaUltMenstruacion,
            KEYS.meses,
            KEYS.fechaNacimiento,
            KEYS.nombre,
            KEYS.idMotivoDescansoMedico,
            KEYS.fechaInicioCondicion,
            KEYS.fechaFinCondicion,
            KEYS.institucionDescansoMedico,
            KEYS.diagnostico,
            KEYS.certificadoFileViewModel,
            KEYS.pagoConsultaFileViewModel,
            KEYS.recetaMedicaFileViewModel,
            KEYS.pagoRecetaMedicaFileViewModel,
            KEYS.descansoMedicoCITTFileViewModel,
            KEYS.descansoMedicoFileViewModel,
            KEYS.anexo18FileViewModel,
            KEYS.ultimoInformeEcograficoFileViewModel
          ])}
        />
      </Div>
    </>
  );

  return (
    <ModalForm
      titulo="Nuevo registro de DM o maternidad"
      width="1100px"
      showModal={toggleModal}
      isSubmitting={isSubmitting}
      saveButtonDisabled={isUploading || isSubmitting || !canCreate()}
      onSubmit={handleSubmit}>
        {fromAdminPage &&
        <Div col={10}>
          <InputSearchAsync typeGet label='Empleado'  api={getEmpleadosToCreateCondicionAPI } {...commonProps('IdEmpleado')} />
        </Div>
      }
      
      <div className="displayFlexWrap">
      
      
        {CommonData}
        {formValues[KEYS.idTipoDeCondicion] ===
          MATERNIDAD_CONDICION.GESTANTE && (
          <Gestante
            commonProps={commonProps}
            selectProps={selectProps}
            isCreate={true}
            keys={KEYS}
          />
        )}
        {formValues[KEYS.idTipoDeCondicion] ===
          MATERNIDAD_CONDICION.LACTANCIA && (
          <Lactancia
            commonProps={commonProps}
            fechaNacimiento={formValues[KEYS.fechaNacimiento]}
            isCreate={true}
            keys={KEYS}
            puedeCrearLactancia={dataToCreate?.PuedeCrearLactancia}
          />
        )}
        {Object.values(MATERNIDAD_CONDICION).includes(
          formValues[KEYS.idTipoDeCondicion]
        ) && (
          <Div>
            {formValues[KEYS.idTipoDeCondicion] ===
              MATERNIDAD_CONDICION.GESTANTE && (
              <span className="required font-size-search-label-text">
                * Se requiere subir la cartilla de control pre natal
              </span>
            )}
            {formValues[KEYS.idTipoDeCondicion] ===
              MATERNIDAD_CONDICION.LACTANCIA && (
              <span className="required font-size-search-label-text">
                * Adjuntar el documento de Acta de Nacimiento o copia de DNI,
                este registro solo se toma para fines de registro de lactancia,
                no significa el pago de asignación familiar
              </span>
            )}
            <InputUploadFile
              label="Sustento"
              name={KEYS.file}
              uploadFile={formValues[KEYS.file]}
              setUploadFile={(res) =>
                setFormValues({ ...formValues, [KEYS.file]: res })
              }
              sectionName={SECTION_NAME}
              setIsUploading={setIsUploading}
              validExtensions={["pdf", "jpg", "png"]}
              isRequired={true}
            />
          </Div>
        )}
        {formValues[KEYS.idTipoDeCondicion] ===
          DM_CONDICION.DESCANSO_MEDICO && (
          <DescansoMedico
            selectProps={selectProps}
            commonProps={commonProps}
            fechaNacimiento={formValues[KEYS.fechaNacimiento]}
            formValues={formValues}
            setFormValues={setFormValues}
            setIsUploading={setIsUploading}
            sectionName={SECTION_NAME}
            KEYS={KEYS}
            dmsAprobadosAcumuladosEsteAnio={dataToCreate?.DMsAprobadosAcumuladosEsteAnio}
            isCreate={true}
            isAdmin={isAdmin}
            puedeVerCamposAdmin={puedeVerCamposAdmin}
            idEmpleado={currentIdEmpleado}
            excede140Consecutivo={dataToCreate?.Excede140Consecutivo}
            excede80NoConsecutivo={dataToCreate?.Excede80NoConsecutivo}
            estariaExcediendo140Consecutivo={dataToCreate?.EstariaExcediendo140Consecutivo}
            estariaExcediendo80NoConsecutivo={dataToCreate?.EstariaExcediendo80NoConsecutivo}
            checkDeclaracionJurada={checkDeclaracionJurada}
            setCheckDeclaracionJurada={setCheckDeclaracionJurada}
          />
        )}

        {formValues[KEYS.idTipoDeCondicion] ===
            DM_CONDICION.LICENCIA && (
                <LicenciaCondicion
                    SECTION_NAME = {SECTION_NAME}
                    idEmpleado={currentIdEmpleado}
                    formValuesLicencias = {formValuesLicencias}
                    setFormValuesLicencias = {setFormValuesLicencias}
                    KEYS = {KEYS_LICENCIAS}
                    fromAdminPage = {fromAdminPage}
                    isCreate = {true}
                    isEditable = {true}
                />
            )}

      </div>
    </ModalForm>
  );
}

CrearMaternidad.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  refreshPage: PropTypes.func
}

export default CrearMaternidad;